// extracted by mini-css-extract-plugin
export default {"paymentHistory":"paymentHistory_paymentHistory__Hegfa","paymentTable":"paymentHistory_paymentTable__bb9R+","tableResponsive":"paymentHistory_tableResponsive__P762b"};